import api from "@/api";

export const campanhasService = {
  // ── Histórico ──
  async getHistorico() {
    const { data } = await api.get("/notificacoes/historico");
    return data;
  },

  // ── Detalhes (destinatários + consumos no intervalo) ──
  async getDetalhesCampanha(id) {
    const { data } = await api.get(`/notificacoes/campanhas/${id}/detalhes`);
    return data;
  },

  // ── Criar / enviar ──
  async criar(payload) {
    const { data } = await api.post("/notificacoes/criar", payload);
    return data;
  },

  // ── Templates Push ──
  async getTemplatesPush() {
    const { data } = await api.get("/notificacoes/templates-push");
    return data;
  },

  async guardarTemplatePush(titulo, mensagem) {
    const { data } = await api.post("/notificacoes/templates-push", {
      titulo,
      mensagem,
    });
    return data;
  },

  // ── Templates WhatsApp ──
  async getTemplatesWhatsapp() {
    const { data } = await api.get("/notificacoes/templates");
    return data;
  },

  async updateTemplate(id, payload) {
    const { data } = await api.put(`/notificacoes/templates/${id}`, payload);
    return data;
  },

  async deleteTemplate(id) {
    const { data } = await api.delete(`/notificacoes/templates/${id}`);
    return data;
  },

  // ── Verificações ──
  async checkWhatsappConfig() {
    const { data } = await api.get("/notificacoes/check-whatsapp-config");
    return data;
  },

  // ── Atualizar datas do evento ──
  async atualizarDatasEvento(id, { inicio, fim }) {
    const { data } = await api.patch(
      `/notificacoes/campanhas/${id}/dia-evento`,
      { inicio, fim },
    );
    return data;
  },

  // ── Apagar campanha ──
  async apagarCampanha(id) {
    const { data } = await api.delete(`/notificacoes/campanhas/${id}`);
    return data;
  },

  // ── Clone ──
  async clonarCampanha(campaignId) {
    const { data } = await api.get(
      `/notificacoes/campanhas/${campaignId}/clone`,
    );
    return data;
  },

  async clonarTemplate(templateId) {
    const { data } = await api.get(
      `/notificacoes/templates/${templateId}/clone`,
    );
    return data;
  },

  // ── Upload imagem ──
  async uploadImagem(formData) {
    const { data } = await api.post("/uploads/imagem", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
};
